import { render } from "./SellerReview.vue?vue&type=template&id=45fbe10a&scoped=true"
import script from "./SellerReview.vue?vue&type=script&lang=js"
export * from "./SellerReview.vue?vue&type=script&lang=js"

import "./SellerReview.vue?vue&type=style&index=0&id=45fbe10a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45fbe10a"]])

export default __exports__